import { ITargetMoistureData } from '../hooks';
import { CalculatorService } from '../services/calculator.service';
import {
  ICalculatorBag,
  IRustmixBuyerOffer,
  ITotalData,
} from '../ts/rustmix-buyer.types';

export const handleTotalData = ({
  rustmixBuyerPrices,
  bagA,
  bagB,
  setShrinkageCoeff,
  setState,
  resData,
  setResData,
  setTotalData,
  targetMoistureData,
  setBagAWeightGain,
  setBagBWeightGain,
  setBagMixedWeightGain,
  setBagAPriceGain,
  setBagBPriceGain,
  setBagMixedPriceGain,
  setBagAPrice,
  setBagBPrice,
  setInitialState,
  setBagAMoistureCoeff,
  setBagBMoistureCoeff,
  setBagMixedMoistureCoeff,
  expertMode,
}: IArgs) => {
  //if (rustmixBuyerPrices?.length > 0) {
  const res = CalculatorService.price_bags(
    rustmixBuyerPrices,
    bagA as ICalculatorBag,
    bagB as ICalculatorBag,
    targetMoistureData.enableMoistenUnmixed,
    parseFloat(targetMoistureData.targetMoisture),
    expertMode,
  );
  setResData(() => ({
    weight: +bagA.weight + +bagB.weight,
    gluten:
      CalculatorService.weighted_average(
        parseFloat(String(+bagA.gluten)),
        parseFloat(String(+bagB.gluten)),
        parseFloat(String(+bagA.weight)),
        parseFloat(String(+bagB.weight)),
      ).toFixed(2) || 0,
    idk:
      CalculatorService.weighted_average(
        parseFloat(String(+bagA.idk)),
        parseFloat(String(+bagB.idk)),
        parseFloat(String(+bagA.weight)),
        parseFloat(String(+bagB.weight)),
      ).toFixed(2) || 0,
    bug:
      CalculatorService.weighted_average(
        parseFloat(String(+bagA.bug)),
        parseFloat(String(+bagB.bug)),
        parseFloat(String(+bagA.weight)),
        parseFloat(String(+bagB.weight)),
      ).toFixed(2) || 0,
    protein:
      CalculatorService.weighted_average(
        parseFloat(String(+bagA.protein)),
        parseFloat(String(+bagB.protein)),
        parseFloat(String(+bagA.weight)),
        parseFloat(String(+bagB.weight)),
      ).toFixed(2) || 0,
    nature:
      CalculatorService.weighted_average(
        parseFloat(String(+bagA.nature)),
        parseFloat(String(+bagB.nature)),
        parseFloat(String(+bagA.weight)),
        parseFloat(String(+bagB.weight)),
      ).toFixed(2) || 0,
    cp:
      CalculatorService.hfn_average(
        parseFloat(String(+bagA.cp)),
        parseFloat(String(+bagB.cp)),
        parseFloat(String(+bagA.weight)),
        parseFloat(String(+bagB.weight)),
      ).toFixed(2) || 0,
    humidity:
      CalculatorService.weighted_average(
        parseFloat(String(+bagA.humidity)),
        parseFloat(String(+bagB.humidity)),
        parseFloat(String(+bagA.weight)),
        parseFloat(String(+bagB.weight)),
      ).toFixed(2) || 0,
    temperature: Math.max(
      23,
      Math.min(+bagA.temperature, +bagB.temperature),
    ).toString(),
    wheatType: Math.round(
      Number(bagA.wheatType) + Number(bagB.wheatType) / 2,
    ).toString(),
  }));
  let res2: any;
  setResData((state: any) => {
    if (expertMode) {
      res2 = CalculatorService.moisture_calc({
        targetMoisture: parseFloat(targetMoistureData.targetMoisture),
        setShrincageCoeff: setShrinkageCoeff,
        setState,
        shrincageCoeff: targetMoistureData.shrincageCoeff,
        bagA: bagA as ICalculatorBag,
        bagB: bagB as ICalculatorBag,
        bagMixed: state as ICalculatorBag,
        bagAPrice: res.bag_a_price,
        bagBPrice: res.bag_b_price,
        bagMixedPrice: res.bag_mixed_price,
        enableMoistenUnmixed: targetMoistureData.enableMoistenUnmixed,
        setBagAWeightGain,
        setBagBWeightGain,
        setBagMixedWeightGain,
        setBagAPriceGain,
        setBagBPriceGain,
        setBagMixedPriceGain,
        setBagAPrice,
        setBagBPrice,
        setBagAMoistureCoeff,
        setBagBMoistureCoeff,
        setBagMixedMoistureCoeff,
      });
    }
    return state;
  });

  setState((state: any) => {
    setTotalData({
      bagAPrice:
        res.bag_a_price + targetMoistureData?.bagA?.weightGain * res.price_a?.price,
      bagAPricePerTon: res.price_a?.price,
      bagAId: res.price_a?.id,
      bagBPrice:
        res.bag_b_price + targetMoistureData?.bagB?.weightGain * res.price_b?.price,
      bagBPricePerTon: res.price_b?.price,
      bagBId: res.price_b?.id,
      resPrice:
        res.bag_mixed_price +
        targetMoistureData?.bagMixed?.weightGain * res.price_m?.price,
      resPricePerTon: res.price_m?.price,
      resId: res.price_m?.id,
      resProfit: res2?.bagMixedProfit,
    });
    return state;
  });
  //}
};

interface IArgs {
  rustmixBuyerPrices: IRustmixBuyerOffer[];
  bagA: IBag;
  bagB: IBag;
  setShrinkageCoeff: (val: number) => void;
  setState: any;
  resData: IBag;
  setResData: any; //(arg: () => IBag) => void;
  setTotalData: (arg: ITotalData) => void;
  targetMoistureData: ITargetMoistureData;
  setBagAWeightGain: (val: number) => void;
  setBagBWeightGain: (val: number) => void;
  setBagMixedWeightGain: (val: number) => void;
  setBagAPriceGain: (val: number) => void;
  setBagBPriceGain: (val: number) => void;
  setBagMixedPriceGain: (val: number) => void;
  setBagAPrice: (val: number) => void;
  setBagBPrice: (val: number) => void;
  setInitialState: () => void;
  setBagAMoistureCoeff: (val: number) => void;
  setBagBMoistureCoeff: (val: number) => void;
  setBagMixedMoistureCoeff: (val: number) => void;
  expertMode: boolean;
}

interface IBag {
  weight: string | number;
  gluten: string | number;
  idk: string | number;
  bug: string | number;
  protein: string | number;
  cp: string | number;
  nature: string | number;
  humidity: string | number;
  temperature: string | number;
  wheatType: string | number;
}
